import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46150f69&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=46150f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46150f69",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgFiligrane: require('/app/components/svg/Filigrane.vue').default,SvgArrowDown: require('/app/components/svg/ArrowDown.vue').default})
